import { handleAction } from 'redux-actions';
import actions from '../actions';

const { edit } = actions.searchKeyword;

const searchKeyword = handleAction(edit, (state, { payload }) => payload, '');

export default searchKeyword;



// WEBPACK FOOTER //
// ./src/reducers/searchKeyword.js